import { render } from "./ViewMileageCase.vue?vue&type=template&id=7219361f"
import script from "./ViewMileageCase.vue?vue&type=script&lang=js"
export * from "./ViewMileageCase.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/ViewMileageCase.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7219361f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7219361f', __exports__)) {
    console.log('reload')
    api.reload('7219361f', __exports__)
  }
  
  module.hot.accept("./ViewMileageCase.vue?vue&type=template&id=7219361f", () => {
    console.log('re-render')
    api.rerender('7219361f', render)
  })

}


export default __exports__